<template>
  <div class="applyMoney">
    <ul class="infoList">
      <li>
        <span class="tit">账户余额：</span>
        <i class="c_0b9e00">{{this.overMoney}} 元</i>
      </li>
      <li>
        <span class="tit">手续费：</span>
        <i class="c_ff0000">{{this.fee}}</i> 元
      </li>
      <li>
        <span class="tit">银行：</span>
        {{this.bankName}}
      </li>
      <li>
        <span class="tit">收款人：</span>
        {{this.realName}}
      </li>
      <li>
        <span class="tit">银行账号：</span>
        {{this.bankNumber}}
      </li>
      <li>
        <span class="tit">申请金额：</span>
        <input class="input" type="number" v-model="applyMoney"> <i class="blue">( ≤ {{this.canMoney}} 元)</i>
      </li>
    </ul>
    <p class="btnbox">
      <!-- <span class="icon_btn" @click="sureMoney"></span> -->
      <van-button size="small" color="linear-gradient(to bottom, #3de9a9, #23cc9a)" @click="sureMoney"><span class="pdl30 pdr30">确认提现</span></van-button>
    </p>
    <div class="tip">
      <p>提现声明：请不要同一天内屡次小额提现，这种情况属于恶意提现，以免财务结算时产生错误对您造成损失。</p>
      <p>到账时间：特殊情况除外，如超过12小时未到账，请与客服联系。</p>
      <p>注意事项：系统结算时间内，提现功能暂不可用。</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      overMoney: 0, // 账户余额
      fee: 0, // 手续费
      bankName: '', // 银行
      realName: '', // 收款人
      bankNumber: '', // 银行账号
      canMoney: 0, // 最大申请金额
      applyMoney: '' // 申请金额
    };
  },
  methods: {
    // 提现信息
    getinfo() {
      this.$api.home
        .getMoney({
          uuid: this.$route.query.uuid
        })
        .then((data) => {
          this.overMoney = data.data.overMoney; // 账户余额
          this.fee = data.data.fee; // 手续费
          this.bankName = data.data.bankName; // 银行
          this.realName = data.data.realName; // 收款人
          this.bankNumber = data.data.bankNumber; // 银行账号
          this.canMoney = data.data.canSettlementMoney; // 最大申请金额
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 确认提现
    sureMoney() {
      if (this.applyMoney === '') {
        this.$toast('请输入申请金额！');
        return;
      } else if (parseFloat(this.applyMoney) > this.canMoney) {
        this.$toast('申请金额不能大于最大提现额！');
        return;
      }
      this.$api.home
        .applyMoney({
          uuid: this.$route.query.uuid,
          amount: parseFloat(this.applyMoney)
        })
        .then((data) => {
          if (data.status === 200) {
            this.$toast('申请成功！');
            this.applyMoney = '';
            this.getinfo();
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    }
  },
  created() {
    this.getinfo();
  }
};
</script>

<style lang="scss" scoped>
.applyMoney {
  .infoList {
    padding-top: 50px;
    font-size: 17px;
    color: #181818;
    text-align: center;
    li {
      margin-bottom: 20px;
      .blue {
        color: #3de9a9;
      }
      .c_0b9e00 {
        color: #0b9e00;
      }
      .c_ff0000 {
        color: #ff0000;
      }
      .input {
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 4px;
        outline: none;
        padding: 0 10px;
        width: 90px;
        &:focus {
          border-color: #1abc9c;
        }
      }
    }
  }
  .btnbox {
    text-align: center;
    margin-top: 35px;
    .icon_btn {
      display: inline-block;
      width: 130px;
      height: 38px;
      background: url(../assets/images/btns2.png) no-repeat center center;
      background-size: 100% auto;
    }
  }
  .tip {
    margin-top: 45px;
    padding: 0 10px 0 20px;
    font-size: 14px;
    color: #ff0101;
  }
}
</style>
